import React from 'react';
import ReactDOM from 'react-dom/client';
import './App.css';
import App from './App';

// Wait for DOM to be fully loaded
const rootElement = document.getElementById('root');

if (rootElement) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
} else {
  console.error('Root element not found! Make sure your index.html has a div with id="root"');
}
